/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

 
 

export enum ElementName {
  PIPE = 'element.pipe',
  ELBOW = 'element.elbow',
  REDUCTION = 'element.reduction',
  TAP = 'element.tap',
  FLATTENING = 'element.flattening',
  FLANGE = 'element.flange',
  PUSH_COVER = 'element.push_cover',
  RIBBED_COVER = 'element.ribbed_cover',
  DOUBLE_ELBOW = 'element.double_elbow',
  FLANGE_CAP = 'element.flange_cap',
  VALVE_CAP = 'element.valve_cap',
  COFFER_VALVE_CAP = 'element.coffer_valve_cap',
  COFFER_CAP = 'element.coffer_cap',
  OVAL_CAP_REGULAR = 'element.oval_cap_regular',
  OVAL_CAP_UNREGULAR = 'element.oval_cap_unregular'
}
